import { EmailAddress } from '../types';

/**
 * Parses a comma-separated string of emails into an array of EmailAddress objects.
 * Filters out invalid emails (must contain @).
 */
export const parseEmailsFromString = (value: string): EmailAddress[] => {
  return value
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter((email) => email && email.includes('@'))
    .map((email) => ({ email, name: '' }));
};

/**
 * Extracts the last partial email being typed from a comma-separated string.
 */
export const getLastPartialEmail = (value: string): string => {
  return value.split(',').pop()?.trim() || '';
};

/**
 * Gets all complete emails from a comma-separated string (excludes the last partial one being typed).
 */
export const getCompleteEmails = (value: string): string[] => {
  const parts = value.split(',').map((e) => e.trim());
  return parts.slice(0, -1).filter((e) => e.includes('@'));
};

/**
 * Adds an email to a comma-separated string, replacing any partial text being typed.
 * Returns the new value with a trailing comma for easy continuation.
 */
export const addEmailToString = (currentValue: string, newEmail: string): string => {
  const normalizedEmail = newEmail.trim().toLowerCase();
  if (!normalizedEmail) return currentValue;

  const completeEmails = getCompleteEmails(currentValue);

  if (completeEmails.includes(normalizedEmail)) {
    return currentValue;
  }

  return completeEmails.length > 0 ?
    `${completeEmails.join(', ')}, ${normalizedEmail}, ` :
    `${normalizedEmail}, `;
};
